import moment from "moment-timezone";
import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";

import Button from "@/components/UI/Button";
import { Button2 } from "@/ui2/atoms/Button";
import { toTitleCase } from "@/utils/filters";
import images from "@/utils/images";

const ArchivedReferralListItem = (props) => {
  const { patient, unarchiveBtnHandler } = props;

  const { created_date, referral_code, referral_status_reason, referral_status_reason_context } =
    patient;

  const createdDate = created_date
    ? moment(parseFloat(created_date) * 1000).format("MM/DD/YYYY")
    : null;

  const formatMobileNumber = (val) => {
    let firstNumber = val.substring(0, 3);
    let middleNumber = val.substring(3, 6);
    let lastNumber = val.substring(6, 10);

    return `(${firstNumber}) ${middleNumber}-${lastNumber}`;
  };

  let mobileListItem = (
    <>
      <div className="d-flex d-lg-none justify-content-between">
        <div className="d-flex fs-14 flex-column" style={{ width: "65%", wordWrap: "break-word" }}>
          <span className="fs-16 tw:font-bold">
            {toTitleCase(patient.first_name + " " + patient.last_name)}
          </span>

          <span>{patient.email}</span>
          <span>{formatMobileNumber(patient.mobile)}</span>
        </div>

        <div className="d-flex fs-14 flex-column">
          <span>{createdDate}</span>
          <span>{referral_status_reason || ""}</span>
          <span>{referral_status_reason_context || ""}</span>
        </div>
      </div>

      <div className="d-flex d-lg-none justify-content-between mt-4">
        <Button
          className="Btn Btn--sec Btn-xs fs-12"
          onClick={() => props.history.push("/app/referral/" + patient["referral_code"])}
        >
          View
        </Button>
      </div>
    </>
  );

  const name = toTitleCase(patient.first_name + " " + patient.last_name);

  let desktopListItem = (
    <div className="row no-gutters d-none d-lg-flex fs-14 align-items-center justify-content-between">
      <div
        className="col-2"
        data-placement="top"
        style={{ overflow: "hidden", textOverflow: "ellipsis" }}
        title={name}
      >
        {name}
      </div>

      <div
        className="col-2"
        data-placement="top"
        style={{ overflow: "hidden", textOverflow: "ellipsis" }}
        title={patient.email}
      >
        {patient.email}
      </div>

      <div className="col-2">{formatMobileNumber(patient.mobile)}</div>
      <div className="col-1">{createdDate}</div>
      <div className="col-1">{referral_status_reason || ""}</div>
      <div className="col-2">{referral_status_reason_context || ""}</div>

      <div className="col-1">
        <Button2
          isDisabled={patient.btnStatus}
          onPress={() => unarchiveBtnHandler(referral_code)}
          size="xs"
          variant="secondary"
        >
          Un-archive
        </Button2>
      </div>

      <div className="col-1 d-flex d-flex tw:justify-center">
        <div className="cursor ml-5">
          <img
            alt="view icon"
            onClick={() => props.history.push("/app/referral/" + patient["referral_code"])}
            src={images("./common/view.png")}
          />
        </div>
      </div>
    </div>
  );

  return (
    <Fragment>
      {mobileListItem}
      {desktopListItem}
    </Fragment>
  );
};

export default withRouter(ArchivedReferralListItem);
